module.exports = "/_next/static/images/othersites-logo-989c5fe1d7ecee32f972c39a2ab62629.png";